import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-common-text-change',
  templateUrl: './common-text-change.component.html',
  styleUrls: ['../parts.css']
})
export class CommonTextChangeComponent implements OnInit {

  boardData: any = {}; // 面板数据
  boardColumnData: Array<any> = []; // 面板表头数据

  columnPopVisible = false;
  columnDisplayText = '文本';
  columnValue;
  columnSelectList = [];

  conditionVisible = false;
  conditionData;

  recipeId;
  relationId;
  categorieId;

  instanceData: any = {}; // 存放实例返填数据
  automation = {
    boardId: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    conditions: [{}],
    columnId: '',
    columnValue: {
      index: ''
    },
    instanceDescription: ''
  };
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardColumnData = this.boardData.boardData.columns;
      for (let column of this.boardColumnData) {
        if (column.type === 'text') {
          this.columnSelectList.push(column);
        }
      }
    }
    if (this.instanceData && JSON.stringify(this.instanceData) !== '{}') {
      if (this.instanceData.config) {
        this.columnValue = this.instanceData.config.columnId;
        this.automation.columnId = this.columnValue;
        this.automation.columnValue = this.instanceData.config.columnValue;
        this.conditionData = this.automation.columnValue.index;
        this.packageData();
        this.initSelectData();
      }
    }
    this.automation.relationId = this.relationId;
    this.automation.categoryId = this.categorieId;
  }

  initSelectData() {
    for (let column of this.columnSelectList) {
      if (this.columnValue === column.id) {
        this.columnDisplayText = column.title;
        break;
      }
    }
  }

  columnValueChange(item) {
    this.columnValue = item.id;
    this.columnDisplayText = item.title;
    this.automation.columnId = this.columnValue;
    this.packageData();
  }

  conditionDataChange() {
    this.automation.columnValue.index = this.conditionData;
    this.packageData();
  }

  packageData() {
    this.automation.instanceDescription = '当 ' + this.columnDisplayText + ' 值变为 ' + this.conditionData + ' 时， 归档这个任务';
    this.nfDataChange.emit(this.automation);
  }

  getSubmitStatus() : boolean {
    return this.columnValue && this.conditionData;
  }
}
